import React from 'react';
import PropTypes from 'prop-types';
import TimeAgo from 'react-timeago';
import { injectIntl, intlShape } from 'react-intl';

import { customFormatter } from './helpers';

const TimeAgoWrapper = ({ date, intl }) => {
  const handleFormatting = (val, unit) => {
    return customFormatter(val, unit, intl.formats);
  };
  return <TimeAgo date={date} minPeriod={60} formatter={handleFormatting} />;
};

TimeAgoWrapper.propTypes = {
  date: PropTypes.number.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(TimeAgoWrapper);
